// extracted by mini-css-extract-plugin
export default {"reactDiagram":"DiagramSystem_reactDiagram__gkX6b"};